import { legalAcceptanceRequired, presentLegalAcceptance } from "./legal_acceptance.js"
export async function requestJson(url, options = {}) {
  const headers = { Accept: "application/json" }
  if (options.body) headers["Content-Type"] = "application/json"
  const token = document.querySelector("meta[name='csrf-token']")?.content
  if (token) headers["X-CSRF-Token"] = token

  try {
    const response = await fetch(url, {
      method: options.method || "GET",
      headers,
      body: options.body ? JSON.stringify(options.body) : undefined,
      credentials: "same-origin",
      signal: options.signal
    })
    const legal = await legalAcceptanceRequired(response)
    if (legal) { presentLegalAcceptance(legal); return false }
    if (!response.ok) {
      // Returning true marks an expected HTTP failure as handled by the caller.
      if (options.onHttpError?.(response) === true) return false
      throw new Error(`Request failed with ${response.status}`)
    }
    return response.status === 204 ? true : response.json()
  } catch (error) {
    if (error.name === "AbortError") return null
    console.error("Reader request failed", error)
    return false
  }
}
